import type { HandFrame, Handedness } from '../domain/types'

interface LandmarkLike { x: number; y: number; z: number }
interface CategoryLike { categoryName?: string; displayName?: string; score?: number }
interface HandResultLike {
  landmarks: LandmarkLike[][]
  handedness?: CategoryLike[][]
}

export function convertHandResult(result: HandResultLike, timestampMs: number, mirrorX: boolean): HandFrame {
  return {
    timestampMs,
    hands: result.landmarks.map((landmarks, index) => {
      const category = result.handedness?.[index]?.[0]
      const label = (category?.categoryName ?? category?.displayName ?? 'Right').toLowerCase()
      const detected: Handedness = label.includes('left') ? 'left' : 'right'
      // MediaPipe handedness assumes selfie-mirrored input. Browser video frames are
      // unmirrored, so user-facing sessions need both their X axis and label flipped.
      const handedness: Handedness = mirrorX ? (detected === 'left' ? 'right' : 'left') : detected
      return {
        handedness,
        confidence: category?.score ?? 0.9,
        landmarks: landmarks.map((point) => ({ x: mirrorX ? 1 - point.x : point.x, y: point.y, z: point.z }))
      }
    })
  }
}
